import ReportsForm from 'src/javascripts/components/reports/ReportsForm';

export default class ReportsNew {

  constructor() {}

  render() {

    ReportsForm();


  }

}
